(function() {

    'use strict';

    angular.module('Services').factory('FleetsTableService', FleetsTableService);
    FleetsTableService.$inject = ['$location', 'FleetService', 'TableLiteFactory', 'toastr', 'Units', '$rootScope'];
    function FleetsTableService($location, FleetService, TableLiteFactory, toastr, Units, $rootScope) {
        return function () {
            const measureUnit = Units.getMeasureUnit($rootScope.GlobalProfile.office.measureUnit);
            const tableData = {
                tableName: 'FleetsTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Add New Fleet',
                        tooltip: 'Add New Fleet',
                        onClick: function(){
                            $location.path('/fleets/add');
                        }
                    }]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                },
                headers: [{
                    label: 'Fleet Code',
                    viewName: 'code',
                    filterName: 'code',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Fleet Name',
                    viewName: 'name',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Description',
                    viewName: 'description',
                    filterName: 'description',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Vehicles',
                    viewName: 'totalVehicles',
                    filterName: 'totalVehicles',
                    /*filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },*/
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Volume Capacity',
                    viewName: 'totalCapacityFormatted',
                    filterName: 'totalCapacity',
                    /*filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },*/
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Status',
                    viewName: 'status',
                    filterName: 'active',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Active', 'Inactive'],
                        onSelect: function(header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model === 'Active';
                            sendRequest(filter);
                        }
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, ],
                data: []
            };
            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: FleetService.Fleets.getAll,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : {
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                if(!data)
                    return null;
                angular.forEach(data.content, function(fleet, index) {
                    fleet.status = {
                        type: 'status',
                        status: fleet.active,
                        label: fleet.active ? 'Active' : 'Inactive'
                    };
                    fleet.totalCapacityFormatted =
                        `${fleet.totalCapacity / (1000000)} ${measureUnit ? (measureUnit === 'CM' ? 'M' : 'F') : 'M'}<sup>3</sup>`;
                    fleet.href = '/fleets/details/' + fleet.id;

                    tableData.data.push(fleet);
                });
                /*** END - Building of Data ***/
            }
            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/FleetsTableService.js